if (!window.customElements.get('free-sample-form')) {
  /**
   * Free Sample Form - adds a sample product to cart with line item properties.
   * Follows the same cart/add.js + event dispatch pattern used by the theme's
   * product-form custom element (theme.js lines 2797-2871).
   */
  class FreeSampleForm extends HTMLElement {
    connectedCallback() {
      this._sampleVariantId = this.getAttribute('sample-variant-id');
      this._sampleProductHandle = this.getAttribute('sample-product-handle');
      this._colorOptionIndex = parseInt(this.getAttribute('color-option-index'), 10);
      this._maxPerOrder = parseInt(this.getAttribute('max-per-order') || '2', 10);
      this._maxReachedMessage = this.getAttribute('max-reached-message') || 'Je kunt maximaal ' + this._maxPerOrder + ' stalen per bestelling aanvragen.';
      this._submitting = false;

      this._kleurInput = this.querySelector('[data-sample-property="kleur"]');
      this._skuInput = this.querySelector('[data-sample-property="sku"]');
      this._button = this.querySelector('button');

      // Listen for variant changes on the main product form
      var productFormId = this.getAttribute('product-form-id');
      this._productForm = document.getElementById(productFormId);
      if (this._productForm) {
        this._onVariantChange = this._handleVariantChange.bind(this);
        this._productForm.addEventListener('variant:change', this._onVariantChange);
      }

      // Handle button click directly
      if (this._button) {
        this._onClick = this._handleClick.bind(this);
        this._button.addEventListener('click', this._onClick);
      }
    }

    disconnectedCallback() {
      if (this._productForm && this._onVariantChange) {
        this._productForm.removeEventListener('variant:change', this._onVariantChange);
      }
      if (this._button && this._onClick) {
        this._button.removeEventListener('click', this._onClick);
      }
    }

    _handleVariantChange(event) {
      var variant = event.detail.variant;
      if (!variant) return;

      if (this._kleurInput && this._colorOptionIndex >= 0) {
        var options = variant.options || [];
        this._kleurInput.value = options[this._colorOptionIndex] || '';
      }

      if (this._skuInput) {
        this._skuInput.value = variant.sku || '';
      }
    }

    async _handleClick() {
      if (this._submitting) return;
      this._submitting = true;

      try {
        // Check cart limits
        var cartResponse = await fetch(Shopify.routes.root + 'cart.js', {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        var cart = await cartResponse.json();

        var sampleCount = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].handle === this._sampleProductHandle) {
            sampleCount += cart.items[i].quantity;
          }
        }

        if (sampleCount >= this._maxPerOrder) {
          window.alert(this._maxReachedMessage);
          return;
        }

        // Build properties from hidden inputs
        var properties = {};
        var propertyInputs = this.querySelectorAll('[data-sample-property]');
        for (var j = 0; j < propertyInputs.length; j++) {
          var input = propertyInputs[j];
          var name = input.getAttribute('name').replace('properties[', '').replace(']', '');
          if (input.value) {
            properties[name] = input.value;
          }
        }

        // Prepare sections to bundle (same pattern as theme.js product-form)
        var sectionsToBundle = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        // POST to cart/add.js (same pattern as theme.js product-form)
        var addResponse = await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(this._sampleVariantId, 10),
              quantity: 1,
              properties: properties
            }],
            sections: sectionsToBundle.join(','),
            sections_url: Shopify.routes.root + 'variants/' + this._sampleVariantId
          })
        });

        var responseJson = await addResponse.json();

        if (addResponse.ok) {
          // Fetch updated cart and dispatch events (same as theme.js)
          var updatedCartResponse = await fetch(Shopify.routes.root + 'cart.js');
          var cartContent = await updatedCartResponse.json();
          cartContent['sections'] = responseJson['sections'];

          this.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson['items'] : [responseJson],
              cart: cartContent
            }
          }));

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          }));
        }
      } finally {
        this._submitting = false;
      }
    }
  }

  window.customElements.define('free-sample-form', FreeSampleForm);
}
